export default "__VITE_ASSET__DXfjKHtM__"